<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4 style="color:white;">Enclosed Area History</h4>
      </div>
    </div>
  </mat-card-header>
  <br/>
  <mat-card-content>

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
    class="mat-elevation-z8">

    <ng-container matColumnDef="enclosedAreaDetermination">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of Determination</th>
      <td mat-cell *matCellDef="let history" style="align-items: center; text-align: center;">
        {{history.enclosedAreaDetermination}}
      </td>
    </ng-container>
    <ng-container matColumnDef="enclosedAreaDeterminationComments">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Determaination Comments</th>
      <td mat-cell *matCellDef="let history">{{history.enclosedAreaDeterminationComments}}</td>
    </ng-container>
    <ng-container matColumnDef="loggedUser">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
      <td mat-cell *matCellDef="let history">{{history.loggedUser}}</td>
    </ng-container>
    <ng-container matColumnDef="timeStamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</th>
      <td mat-cell *matCellDef="let history">
        {{history.timeStamp}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
  </table>
  <br/>
  <div style="padding-right: 20px;">
    <button mat-raised-button (click)="return()" style="padding-right: 20px;">
      Return
    </button>
  </div>
  </mat-card-content>

</mat-card>

<!-- <div class="modal fade" id="enclosedAreaModalEditHistory" tabindex="-1" role="dialog" aria-labelledby="enclosedAreaModalEditHistoryLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title " id="enclosedAreaModalEditHistoryLabel">Enclosed Area Edit History</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body" id="enclosedAreaModalEditHistoryBody">
              <label class="text-muted">Edit History</label>
              <table class="table table-striped" id="enTable2">
                  <thead>
                      <tr>
                          <th>Date of Determination</th>
                          <th>Determination Comments</th>
                          <th>User</th>
                          <th>Last Updated</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr ng-repeat="enh in enclosedAreaEditHistorySelected">
                          <td>{{enh.EnclosedAreaDetermination}}</td>
                          <td><span style="white-space: pre-wrap">{{enh.EnclosedAreaDeterminationComments}}</span></td>
                          <td>{{enh.LoggedUser}}</td>
                          <td>{{enh.TimeStamp}}</td>
                      </tr>
                      <tr>
                          <td>{{enclosedArea.EnclosedAreaHistory[enclosedAreaEditHistorySelectedIndex].EnclosedAreaDetermination}}</td>
                          <td>{{enclosedArea.EnclosedAreaHistory[enclosedAreaEditHistorySelectedIndex].EnclosedAreaDeterminationComments}}</td>
                          <td>{{enclosedArea.EnclosedAreaHistory[enclosedAreaEditHistorySelectedIndex].LoggedUser}}</td>
                          <td>{{enclosedArea.EnclosedAreaHistory[enclosedAreaEditHistorySelectedIndex].TimeStamp}}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>

          </div>
      </div>
  </div>
</div> -->